/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Control } from './Control';
import {
    ControlFromJSON,
    ControlFromJSONTyped,
    ControlToJSON,
    ControlToJSONTyped,
} from './Control';

/**
 * Lightweight template descriptor for the list (`?view=summary`) view.
 * 
 * Carries the template's filter shape — controls and default range — but not its layout, so
 * a client can build the filter bar and issue a correctly-filtered render straight away.
 * @export
 * @interface DashboardSummary
 */
export interface DashboardSummary {
    /**
     * Template id
     * @type {string}
     * @memberof DashboardSummary
     */
    id: string;
    /**
     * Human-readable template name
     * @type {string}
     * @memberof DashboardSummary
     */
    name: string;
    /**
     * Product families this dashboard is about, so a client can scope its deployment picker to them. Empty means no constraint.
     * @type {Array<string>}
     * @memberof DashboardSummary
     */
    products?: Array<DashboardSummaryProductsEnum>;
    /**
     * 
     * @type {string}
     * @memberof DashboardSummary
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardSummary
     */
    defaultTimeRange?: string | null;
    /**
     * The template's controls, so a client knows its filters before rendering
     * @type {Array<Control>}
     * @memberof DashboardSummary
     */
    controls?: Array<Control>;
}


/**
 * @export
 */
export const DashboardSummaryProductsEnum = {
    Ring: 'RING',
    Adi: 'ADI',
    Artesca: 'ARTESCA'
} as const;
export type DashboardSummaryProductsEnum = typeof DashboardSummaryProductsEnum[keyof typeof DashboardSummaryProductsEnum];


/**
 * Check if a given object implements the DashboardSummary interface.
 */
export function instanceOfDashboardSummary(value: object): value is DashboardSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function DashboardSummaryFromJSON(json: any): DashboardSummary {
    return DashboardSummaryFromJSONTyped(json, false);
}

export function DashboardSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'products': json['products'] == null ? undefined : json['products'],
        'description': json['description'] == null ? undefined : json['description'],
        'defaultTimeRange': json['defaultTimeRange'] == null ? undefined : json['defaultTimeRange'],
        'controls': json['controls'] == null ? undefined : ((json['controls'] as Array<any>).map(ControlFromJSON)),
    };
}

export function DashboardSummaryToJSON(json: any): DashboardSummary {
    return DashboardSummaryToJSONTyped(json, false);
}

export function DashboardSummaryToJSONTyped(value?: DashboardSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'products': value['products'],
        'description': value['description'],
        'defaultTimeRange': value['defaultTimeRange'],
        'controls': value['controls'] == null ? undefined : ((value['controls'] as Array<any>).map(ControlToJSON)),
    };
}

